export let marchAbbreviatedLowercase = "T1yPRe";
export default {marchAbbreviatedLowercase};